import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'

type Props = {
  showAlertUpdateModal: boolean
  handleShowUpdateProfileModal: any
}

const AlertUpdateProfileContent: FC<Props> = ({
  showAlertUpdateModal,
  handleShowUpdateProfileModal,
}) => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(showAlertUpdateModal)
  }, [showAlertUpdateModal])

  const handleCloseModal = () => {
    setShowModal(false)
    handleShowUpdateProfileModal(true)
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10'>
        <img
          src={require('../../assets/img/update-profile-image.png')}
          alt='PANA'
          style={{height: 'auto', width: '100%'}}
        />

        <p className='h6 text-center mt-5'>Pembaruan Profil</p>
        <p>
          Demi kelengkapan data pengguna, kami mohon kesediaan Anda untuk memperbarui profil.
          Informasi yang akurat akan sangat membantu kami dalam memberikan layanan yang optimal.
        </p>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={handleCloseModal}
        >
          Perbarui Sekarang!
        </button>
      </div>
    </Modal>
  )
}

const AlertUpdateProfileModal: FC<Props> = ({
  showAlertUpdateModal,
  handleShowUpdateProfileModal,
}) => {
  return (
    <AlertUpdateProfileContent
      showAlertUpdateModal={showAlertUpdateModal}
      handleShowUpdateProfileModal={handleShowUpdateProfileModal}
    />
  )
}

export default AlertUpdateProfileModal
